import AxiosHelper from '../api/AxiosHelper';
import useAuth from './useAuth';
import Constants from './../utils/constants';

const useRefreshToken = () => {
    const { setAuth, setReady, setRole, setPanel, setEmployeeId } = useAuth();

    const refresh = () => {
        AxiosHelper.refresh().then((res) => {
            if (res.status === 200) {
                const auth = res.data;
                const role = auth.role;
                setAuth(prev => { return {...prev, ...auth } });
                setEmployeeId(auth?.employeeId);
                
                switch(role.type) {
                    case Constants.ROOT:
                    case Constants.ADMIN:
                        setRole('ADMIN');
                        setPanel('ADMIN');
                        break;
                    case Constants.STAFF:
                        setRole('STAFF');
                        setPanel('STAFF');
                        localStorage.setItem('panel', 'STAFF');
                        break;
                    default:
                        setRole();
                        setPanel('ADMIN');
                        break;

                }
                setPanel(localStorage.getItem('panel'));
                setReady(true);
            }
        }).catch((error) => {
            setAuth(prev => {
                return {...prev, token: 'Unauthorized' }
            });
            setReady(false);
        });
    }

    return refresh;
}

export default useRefreshToken;